<div class="fresh-ui m-padding-card">
    <div class="new-video-post-card">
        <div class="video-post-thumbnail position-relative"
            (click)="premiumInvites(video,true)">
            <div class="badge-video">
                Video
            </div>
            <img *ngIf="video?.ThumbnailImage && video?.ThumbnailImage.length"
                width="100%" height="100%"
                src="{{assetURL}}/{{video?.ThumbnailImage}}" class="t-image"
                [alt]="video?.NameEnglish">

            <!-- <div class="video-length">
                {{video?.Duration}}
            </div>
            <div
                class="play-button MarketingVideoModal-module--playButton--2-IH2"></div> -->
        </div>
        <div class="video-post-content">
            <!-- <div
                class="form-row mb-1 align-items-center justify-content-between">
                <div class="col-md">
                    <a (click)="premiumInvites(video)"
                        [ngStyle]="{'display': (video?.DisplayType==2) ? '' : 'none'}">
                        <div class="p-icon">
                            <img src="/assets/images/premium-invites.svg"
                                class="premium-icon-card"
                                alt="Premium invite">
                            <div class="text-container">
                                <div class="p-text text default-text">
                                    Premium invite
                                </div>
                                <div class="p-text text hover-text">
                                    What's Premium?
                                </div>
                            </div>
                        </div>
                    </a>
                    <a
                        [ngStyle]="{'display': (video?.DisplayType==1) ? '' : 'none'}">
                        <div class="d-flex align-item-center p-icon l-icon">
                            <div class="l-text">
                                Landscape invite
                            </div>
                        </div>
                    </a>
                </div>
            </div> -->
            <h3 class="heading cursor-pointer general_sans">
                <a
                    [routerLink]="'/preview/' + video.NameEnglish + '/video' | formateUrl:'videoId=' + video.VideoId"
                    target="_blank">{{video.NameEnglish}}</a>
            </h3>
            <a
                [routerLink]="'/preview/' + video.NameEnglish + '/video' | formateUrl:'videoId=' + video.VideoId"
                target="_blank">
                <div
                    class="form-row justify-content-center align-items-center">
                    <div class="col-md-auto col-auto">
                        <div class="price general_sans"
                            *ngIf="sharedService.userCountry=='US'">
                            <span> ${{video.FinalPrice}}</span>
                            <span *ngIf="video.FinalPrice!=video.Price"
                                class="text-muted ml-1"><small><del>
                                        ${{video.Price}}</del></small></span>
                        </div>
                        <div class="price general_sans"
                            *ngIf="sharedService.userCountry=='AE'">
                            <span> AED {{video.FinalPriceAED}} </span>
                            <span *ngIf="video.FinalPriceAED!=video.PriceAED"
                                class="text-muted ml-1"><small><del>
                                        AED
                                        {{video.PriceAED}}</del></small></span>
                        </div>
                        <div class="price general_sans"
                            *ngIf="sharedService.userCountry=='IN'">
                            <span>₹{{video.FinalPriceINR}}</span>
                            <span *ngIf="video.FinalPriceINR!=video.PriceINR"
                                class="text-muted ml-1"><small><del>
                                        ₹{{video.PriceINR}}</del></small></span>
                        </div>
                    </div>
                    <!-- <div class="col-auto">
                        <div class="video-stats">
                            {{video.NumberOfViews}} Views
                        </div>
                    </div> -->
                </div>
            </a>
        </div>

    </div>
</div>